<template>
  <div class="app-container">
    <div class="white-block-view-5px padding-15 column-view all-view" v-loading="loading" element-loading-text="加载中...">
      <div class="column-view" v-if="!loading">
        <div class="row-view padding-top-10 padding-bottom-10" style="background-color: #f8f8f9;font-size: 16px;color: #5a516e;font-weight: bold">
          <div style="width: 200px;text-align: center;">部门名称</div>
          <div class="flex-1" >职务人员</div>
          <div style="width: 200px;text-align: center">操作</div>
        </div>
        <div class="line-e6"></div>

        <div class="column-view" v-if="parts.length>0">
          <div class="column-view" v-for="(item,index) in parts" :key="index">
            <div class="row-view padding-top-12 padding-bottom-12" style="font-size: 14px;color: #000;" >
              <div style="width: 200px;text-align: center;font-weight: bold">{{item.dept_name}}</div>
              <div class="flex-1 row-view">
                <div v-for="(leader,position) in item.posts" class="flex-1" :class="{ 'flex-2':position===1 }" :style="{ flex : position===0?(1.5):'' }" >{{leader.post_name+':'+getEmployees(leader.employees)}}</div>
                <div v-if="item.posts.length<5" class="flex-1" v-for="item1 in (5-item.posts.length)">
                </div>
              </div>
              <div style="width: 200px;text-align: center" class="row-view center-view">
                <el-button type="text" @click="onEditClick(item)">编辑</el-button>
                <el-button type="text" v-if="index!==0" style="color: #f56c6c" @click="onDeleteClick(item)">删除</el-button>
                <el-button type="text" v-if="index==0" @click="onCreateDepartment">新增部门</el-button>
              </div>
            </div>
            <div class="line-e6"></div>
          </div>
        </div>
        <yc-no-content v-else des="还没有相关部门哦~"></yc-no-content>

      </div>

    </div>

    <create-edit-partment-dialog ref="dialog" @onRefreshData="searchDepartment"></create-edit-partment-dialog>
  </div>

</template>

<script>
import ycNoContent from  '@/components/commonComponents/yc-no-content'
import createEditPartmentDialog from "@/views/setting/departmentManagement/components/createEditPartmentDialog";
export default {
  //部门管理
  name: "DepartmentManagement",
  components:{createEditPartmentDialog,ycNoContent},
  data(){
    return{
      loading:false,
      parts:[
      ]
    }
  },
  methods:{
    searchDepartment(){
      this.loading=true;
      this.http.api('departmentList',{})
          .then(res=>{
            this.loading=false;
            if(res.status){
              this.parts=res.data;
            }else{
              this.$commonUtils.showMessage(res.message,'error')
            }
          })
          .catch(error=>{
            this.loading=false;
          })
    },

    getEmployees(item){
      if(item&&item.length>0){
        return item.map(user => user.employee_name).join(', ')
      }
      return ''

    },

    onDeleteClick(item){
      this.$prompt('确认删除部门【'+item.dept_name+'】?', '删除部门', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            this.http.api('deleteDepartment', { id: item.id }).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
                done()
                this.$commonUtils.showMessage('操作成功','success')
                this.searchDepartment()
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '删除'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })

    },

    onEditClick(item){
      item.posts.forEach(post=>{
        post.employee_ids=post.employees.map(employee => employee.employee_id)
      })
      this.$refs.dialog.setData(item)
    },
    onCreateDepartment(){
      this.$refs.dialog.showDialog();
    },

  },
  created() {
    this.searchDepartment();
  }
}
</script>

<style scoped lang="scss">


</style>
